/* Geotarget menu and content */
(() => {
  const HEADER_ID_MEGA = 'HeaderMenu-compra-online';
  const HEADER_ID_DRAWER = 'HeaderDrawer-compra-online';
  const COLLECTION_ID = 'shopify-section-template--28141148504395__featured_collection_4hFRnC';
  const ALT_SECTION_ID = 'shopify-section-template--28141148504395__image_with_text_8gyGqj';

  const LOCALE_ROOT = window.Shopify?.routes?.root || '/';
  const BCN_URL = `${LOCALE_ROOT}pages/compra-online`;
  const CACHE_KEY = 'geo_city_v1';
  const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

  function setInBCN() {
    document.getElementById(HEADER_ID_MEGA)?.setAttribute('href', BCN_URL);
    document.getElementById(HEADER_ID_DRAWER)?.setAttribute('href', BCN_URL);

    document.getElementById(COLLECTION_ID)?.setAttribute('style', 'display: block;');
    document.getElementById(ALT_SECTION_ID)?.setAttribute('style', 'display: none;');
  }

  function readCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (!data || !data.city || !data.ts) return null;
      if (Date.now() - data.ts > CACHE_TTL_MS) return null;
      return data;
    } catch {
      return null;
    }
  }

  function writeCache(city, country) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ city, country, ts: Date.now() })
      );
    } catch {}
  }

  async function getShopifyCountry() {
    const r = await fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' });
    if (!r.ok) return null;
    const data = await r.json();
    // In practice this returns detected country info; handle is typically ISO like "ES"
    return data?.detected_values?.country?.handle || null;
  }

  async function getCityViaIpApi() {
    // Choose ONE provider. ipapi.co is simple for prototypes.
    // Consider replacing with your paid provider or edge proxy later.
    const r = await fetch('https://ipapi.co/json/', { mode: 'cors' });
    if (!r.ok) return null;
    const data = await r.json();
    return {
      city: (data?.city || '').trim(),
      country: (data?.country || data?.country_code || '').trim()
    };
  }

  function isBarcelona(city) {
    return city && city.toLowerCase() === 'barcelona';
  }

  async function run() {
    document.getElementById(COLLECTION_ID)?.setAttribute('style', 'display: none;');

    // Use cached city if available
    const cached = readCache();
    if (cached) {
      if (cached.country === 'ES' && isBarcelona(cached.city)) setInBCN(BCN_URL);
      return;
    }

    // Gate by country first (free + fast)
    const country = await getShopifyCountry();
    if (country !== 'ES') return;

    // City lookup (external)
    const geo = await getCityViaIpApi();
    if (!geo) return;

    // Normalize country code returned by provider (often "ES")
    const geoCountry = (geo.country || '').toUpperCase();
    const geoCity = geo.city || '';

    writeCache(geoCity, geoCountry);

    if (geoCountry === 'ES' && isBarcelona(geoCity)) {
      setInBCN();
    }
  }

  // Taste menus are in DOM at load; run at DOMContentLoaded.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
